module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "panel panel-default panel-search"
  }, [_c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "编码"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.page.query.param.code),
      callback: function($$v) {
        _vm.$set(_vm.page.query.param, "code", $$v)
      },
      expression: "page.query.param.code"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "名称"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.page.query.param.name),
      callback: function($$v) {
        _vm.$set(_vm.page.query.param, "name", $$v)
      },
      expression: "page.query.param.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "状态"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "clearable": true
    },
    model: {
      value: (_vm.page.query.param.status),
      callback: function($$v) {
        _vm.$set(_vm.page.query.param, "status", $$v)
      },
      expression: "page.query.param.status"
    }
  }, _vm._l((_vm.$dict.store.PROMOTION_STATUS), function(item) {
    return _c('el-option', {
      key: item[0],
      attrs: {
        "value": item[0],
        "label": item[1]
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    directives: [{
      name: "keycode",
      rawName: "v-keycode",
      value: ('ENTER'),
      expression: "'ENTER'"
    }],
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.create
    }
  }, [_vm._v("新增")])], 1)], 1)], 1), _vm._v(" "), _c('v-table', {
    ref: "table",
    attrs: {
      "page": _vm.page,
      "table-minheight": 450
    },
    on: {
      "dataloaded": _vm.onDataloaded
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "code",
      "label": "编码",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "名称",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "startOn",
      "label": "开始时间",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "endOn",
      "label": "结束时间",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "effectDays",
      "label": "有效期",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_vm._v("\n        " + _vm._s(row.effectTimes) + " " + _vm._s(_vm.$dict.getText(row.effectTimeUnit, _vm.$dict.store.PROMOTION_EFFECT_TIMEUNIT)) + "\n      ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "visibility",
      "label": "可见性",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_vm._v("\n        " + _vm._s(_vm.$dict.getText(row.visibility, _vm.$dict.store.PROMOTION_VISIBILITY)) + "\n      ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "tip",
      "label": "优惠"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_vm._v("\n        " + _vm._s(row.discountValue) + " "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (row.discountType == 1),
            expression: "row.discountType==1"
          }]
        }, [_vm._v("元")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "tip",
      "label": "总量/发放/使用",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_vm._v("\n        " + _vm._s(row.limitTotalNum ? row.limitTotalNum : '不限') + " / " + _vm._s((_vm.summaryMap[row.id] || {
          instanceNum: 0
        }).instanceNum) + " /  " + _vm._s((_vm.summaryMap[row.id] || {
          usedNum: 0
        }).usedNum) + "\n      ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "状态",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_vm._v("\n        " + _vm._s(_vm.$dict.getText(row.status, _vm.$dict.store.PROMOTION_STATUS)) + "\n      ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createOn",
      "width": "140",
      "label": "创建时间"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_vm._v("\n        " + _vm._s(row.createOn) + "\n      ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "100",
      "label": "操作",
      "fixed": 'right'
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "title": "上/下架"
          },
          on: {
            "click": function($event) {
              return _vm.toggleStatus(scope.row)
            }
          }
        }, [_c('i', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.status == 0 || scope.row.status == 2),
            expression: "scope.row.status==0||scope.row.status==2"
          }],
          staticClass: "el-icon-upload2"
        }), _vm._v(" "), _c('i', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.status == 1),
            expression: "scope.row.status==1"
          }],
          staticClass: "el-icon-download"
        })]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text",
            "title": "编辑"
          },
          on: {
            "click": function($event) {
              return _vm.edit(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-edit"
        })])]
      }
    }])
  })], 1), _vm._v(" "), _c('v-dialog', {
    ref: "formDiag",
    attrs: {
      "title": "信息编辑"
    }
  }, [_c('form-panel', {
    on: {
      "saved": _vm.onFormSaved
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.formDiag.dispatch('submit')
      }
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f83752d","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/app/act/promotionInfo/Manage.vue
// module id = 333
// module chunks = 0